
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexQLbd_45_VEGEymTy61om4OM78JfxLHuFgCIu_qxD7KdRoMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as _91id_93r3X3zmZmoe4wxH_Zb7Da26CVLJJu_WIVAKF7VbeTG0IMeta } from "/opt/buildhome/repo/pages/cupons/[id].vue?macro=true";
import { default as novo7x0ml3ePnOWdslEeym9MfuV7DMFE9eT80CW_NSuc5eUMeta } from "/opt/buildhome/repo/pages/cupons/novo.vue?macro=true";
import { default as indexpMhRwMFHh6TMMkzbObc4e30ErIL7q_3QRNJsBhUdJJAMeta } from "/opt/buildhome/repo/pages/cupons/index.vue?macro=true";
import { default as indexlCs0oaxBcVnAdViwLOJYlyk2cYtbOlZlfWrj9ORpXEYMeta } from "/opt/buildhome/repo/pages/pedidos/index.vue?macro=true";
import { default as indexK1xKK_FclpgZ7EQc2gd7XFLoe5P7sxhGGWlj2FjwOwgMeta } from "/opt/buildhome/repo/pages/auditoria/index.vue?macro=true";
import { default as indexJvs957I6wedDLgwZgBTn8an_wtqWvVmxCZB7Arhxm_45YMeta } from "/opt/buildhome/repo/pages/logistica/index.vue?macro=true";
import { default as indexxxWcSQD_45I5lUz213tXZuTTEfElcyZSwxpbp4ghl4FC4Meta } from "/opt/buildhome/repo/pages/orcamentos/index.vue?macro=true";
import { default as indexyYBqhvSZV4lPhiD2ukcoYOjTUWN5Ck5SXWAI3oTIzigMeta } from "/opt/buildhome/repo/pages/pedidos/[id]/index.vue?macro=true";
import { default as index53hSQyJnIqXxpCc_gQf7IhgtuenF5yQeg5WF0dgqrJEMeta } from "/opt/buildhome/repo/pages/planejamento/index.vue?macro=true";
import { default as indexT7i0YR_45u4rJlSODJOp8QjDjki7yfiMZ9BNji9fWkn4cMeta } from "/opt/buildhome/repo/pages/precificacao/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "cupons-id",
    path: "/cupons/:id()",
    meta: {"middleware":["cupons"]},
    component: () => import("/opt/buildhome/repo/pages/cupons/[id].vue")
  },
  {
    name: "cupons-novo",
    path: "/cupons/novo",
    meta: {"middleware":["cupons"]},
    component: () => import("/opt/buildhome/repo/pages/cupons/novo.vue")
  },
  {
    name: "cupons",
    path: "/cupons",
    meta: {"middleware":["cupons"]},
    component: () => import("/opt/buildhome/repo/pages/cupons/index.vue")
  },
  {
    name: "pedidos",
    path: "/pedidos",
    component: () => import("/opt/buildhome/repo/pages/pedidos/index.vue")
  },
  {
    name: "auditoria",
    path: "/auditoria",
    component: () => import("/opt/buildhome/repo/pages/auditoria/index.vue")
  },
  {
    name: "logistica",
    path: "/logistica",
    component: () => import("/opt/buildhome/repo/pages/logistica/index.vue")
  },
  {
    name: "orcamentos",
    path: "/orcamentos",
    component: () => import("/opt/buildhome/repo/pages/orcamentos/index.vue")
  },
  {
    name: "pedidos-id",
    path: "/pedidos/:id()",
    meta: {"middleware":["pedidos"]},
    component: () => import("/opt/buildhome/repo/pages/pedidos/[id]/index.vue")
  },
  {
    name: "planejamento",
    path: "/planejamento",
    component: () => import("/opt/buildhome/repo/pages/planejamento/index.vue")
  },
  {
    name: "precificacao",
    path: "/precificacao",
    component: () => import("/opt/buildhome/repo/pages/precificacao/index.vue")
  }
]